/* globals PLUG */

(function (CartTemplate) {

    let U;

    const internalEmailSuffix = "@textron.com";
    const payLaterCartAttributes = PLUG.payLaterCartAttributes.slice(0);

    CartTemplate.export = function () {
        U = PLUG.import("Utils");
        return Object.freeze({ init });
    };

    function init() {
        const customerEmail = PLUG.customer.email;
        const isInternal = customerEmail.includes(internalEmailSuffix);

        if (isInternal) {
            const netInvoiceBtn = document.getElementById("checkout-net-invoice");
            netInvoiceBtn.addEventListener("click", () => {
                U.setButtonLoadingState(netInvoiceBtn, true);
                setPayLaterAttributes("net", (data, err) => {
                    U.setButtonLoadingState(netInvoiceBtn, false);
                    if (err) throw err;
                    location.href = "/pages/CML_checkout";
                });
            }, false);
        } else {
            const payAtCheckoutBtn = document.getElementById("checkout");
            payAtCheckoutBtn.addEventListener("click", (e) => {
                e.preventDefault();
                U.setButtonLoadingState(payAtCheckoutBtn, true);
                clearPayLaterAttributes((data, err) => {
                    U.setButtonLoadingState(payAtCheckoutBtn, false);
                    if (err) throw err;
                    location.href = "/checkout";
                });
            }, false);

            clearPayLaterAttributes((data, err) => {
                if (err) throw err;
            });
        }

        // This was used for "direct" pay later orders, as opposed to "net".
        // It can safely be removed if "direct" is no longer needed.
        //
        // const directInvoiceBtn = document.getElementById("checkout-direct-invoice");
        // directInvoiceBtn.addEventListener("click", () => {
        //     U.setButtonLoadingState(directInvoiceBtn, true);
        //     setPayLaterAttributes("direct", (data, err) => {
        //         U.setButtonLoadingState(directInvoiceBtn, false);
        //         if (err) throw err;
        //         location.href = "/pages/CML_checkout";
        //     });
        // }, false);
    }

    function clearPayLaterAttributes(cb) {
        const requestData = { attributes: {} };
        payLaterCartAttributes.forEach((attributeName) => {
            requestData.attributes[attributeName] = "";
        });
        U.makeXmlRequest({
            method: "POST",
            url: "/cart/update.js",
            headerData: { "Content-Type": "application/json" },
            requestBody: JSON.stringify(requestData)
        }, cb);
    }

    function setPayLaterAttributes(invoiceType, cb) {
        U.makeXmlRequest({
            method: "POST",
            url: "/cart/update.js",
            headerData: { "Content-Type": "application/json" },
            requestBody: JSON.stringify({
                attributes: {
                    CML_payment: "pay_later",
                    invoice_type: invoiceType,
                    dealer_account_number: PLUG.customer.accountNumber || "internal"
                }
            })
        }, cb);
    }

})(PLUG.CartTemplate = Object.create(null));
